import { SimplePropertyInfo } from "../Services/ProjectCapacityService";

/** Lowercase entire string and uppercase on first char
 * @description consider using "text-transform: capitalize" to handle it with accelerated CSS
 */
export const formatAsTitle = (text: string): string => {
    if (!text) return null;
    return text.toLowerCase().replace(/^\w/, c => c.toUpperCase());
};

export const replaceAll = (str: string, find: string, replace: string): string => {
    return str.replace(new RegExp(find, 'g'), replace);
};

export const isAllUpperCase = (str: string): boolean => {
    return str === str.toUpperCase();
};

export const isNullOrWhiteSpace = (str: string): boolean => {
    return str == null || !str.replace(/\s/g, '').length;
};

export const isNullUndefinedOrEmpty = (str: any) => {
    return (str ?? '') === '';
};

export const splitCamelCase = (str: string): string => {
    // do not split abbrevations
    if (isAllUpperCase(str)) return str;
    return str.split(/(?=[A-Z])/).join(' ');
};

export const toLowercaseSafe = (str: string): string => {
    if (str == null) return null;
    return str.toLocaleLowerCase();
};

export const asSimplePropertyInfo = (input: string): SimplePropertyInfo => {
	// Unique case for rbs property, has to be fully capitaqlized but originates in FE as all lowercase
	if (input === 'rbs') return { PropertyName: 'rbs', DisplayName: 'RBS' };
	
	// Add a space before each uppercase letter preceded by a lowercase letter
	const displayName = input.replace(/^./, char => char.toUpperCase()).replace(/([a-z])([A-Z])/g, '$1 $2');

	// Return simple "fake" property info, can be useful when needing propertyinfo for the auto-generated interface types
	// These cannot have their keys extracted at runtime, and so when we use a whitelist of these properties, we are sure they exist, but we don't have nice frontend display names
	// Fx. for the order by in the overview, we need this to be able to show the options in a nice way in the menu
    return { PropertyName: input, DisplayName: displayName } as SimplePropertyInfo;
};

export const asSimplePropertyInfoInclCustomFields = (input: string): SimplePropertyInfo => {
	// Unique case for CustomProperties - Has to use schemahelper to look it up
	if (input.startsWith('customProperties.')) {
		
	}

	// Unique case for rbs property, has to be fully capitaqlized but originates in FE as all lowercase
	if (input === 'rbs') return { PropertyName: 'rbs', DisplayName: 'RBS' };
	
	// Add a space before each uppercase letter preceded by a lowercase letter
	const displayName = input.replace(/^./, char => char.toUpperCase()).replace(/([a-z])([A-Z])/g, '$1 $2');

	// Return simple "fake" property info, can be useful when needing propertyinfo for the auto-generated interface types
	// These cannot have their keys extracted at runtime, and so when we use a whitelist of these properties, we are sure they exist, but we don't have nice frontend display names
	// Fx. for the order by in the overview, we need this to be able to show the options in a nice way in the menu
    return { PropertyName: input, DisplayName: displayName } as SimplePropertyInfo;
};

export const StringEx = {
    formatAsTitle,
    replaceAll,
    isAllUpperCase,
    isNullOrWhiteSpace,
    splitCamelCase,
    toLowercaseSafe,
};
